<div class="page" style="background-image: url('{{ backgroundImage }}')">
  <div class="topbar-container">
    <app-besharp-topbar
      [title]="title"
      [logo]="logo"
      [stickyBar]="true"
      [height]="60"
      [scrollThreshold]="30"
      [homeRoute]="homeRoute"
      [topbarItems]="topBarItems"
      [mobileMenu]="mobileMenu"
      [mobileMenuList]="mobileMenuListItems"
    >
      <ng-template #topbarRightBefore>
        <span style="color: white; margin-right: 1rem;">{{ getUserEmail() }}</span>
      </ng-template>
      <ng-template #topbarRightAfter>
        <p-divider layout="vertical" />
        <app-besharp-active-session-badge></app-besharp-active-session-badge>
      </ng-template>
    </app-besharp-topbar>
  </div>

  <div class="sidebar-container" [class.collapsed]="collapsed" [class.mobile-hidden]="isMobile" *ngIf="!isMobile">
    <app-besharp-sidebar
      [sidebarConfiguration]="sidebarConfiguration"
      (collapsedChange)="onSidebarCollapseChanged($event)"
    >
      <ng-template #sidebarFooterTemplate>
        <p-divider layout="horizontal" />
        <footer>
          <span>OTA Portal v0.0.1</span>
        </footer>
      </ng-template>
    </app-besharp-sidebar>
  </div>
  <div class="content-container" [class.collapsed-sidebar]="collapsed" [class.mobile-fullwidth]="isMobile">
    <app-besharp-breadcrumbs homePath="/app"></app-besharp-breadcrumbs>
    <router-outlet></router-outlet>
  </div>
</div>

<app-aic-token-modal
  [(visible)]="showAicTokenModal"
  [userId]="userId"
  (tokenSaved)="onAicTokenSaved()"
></app-aic-token-modal>
